var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerZ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.885 31.3701H25.505V29.8701H27.885V31.3701ZM21.505 31.36H18.505V29.8501H21.505V31.36ZM14.505 31.3501H11.505V29.8501H14.505V31.3501ZM7.50504 31.3401H4.50504V29.83H7.50504V31.3401ZM5.80504 28.8201L4.64503 27.8701L6.54504 25.55L7.70505 26.5001L5.80504 28.8201ZM10.235 23.4001L9.07504 22.4501L10.975 20.1301L12.135 21.08L10.235 23.4001ZM14.665 17.9801L13.505 17.0301L15.405 14.7101L16.565 15.6601L14.665 17.9801ZM19.095 12.5601L17.935 11.61L19.8351 9.29007L20.995 10.2401L19.095 12.5601ZM23.525 7.14005L22.3651 6.19006L24.265 3.87006L25.425 4.82005L23.525 7.14005ZM3.28503 2.12006V0.620056H6.27504V2.12006H3.28503ZM10.285 2.10007V0.600067H13.275V2.10007H10.285ZM17.285 2.08006V0.580063H20.275V2.08006H17.285ZM24.285 2.06006V0.560059H27.275V2.06006H24.285Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerZ);
export default __webpack_public_path__ + "static/media/LOWER_Z.96b7a78558ea78c16aa024cc019a8377.svg";
export { ForwardRef as ReactComponent };